import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import {
  clearSelectedEmployees,
  hasMeaningfulInviteFormData,
  loadInviteFormData,
  loadSelectedEmployees,
  saveSelectedEmployees,
} from './invite-session-storage';

export const useInviteSelectedEmployees = (eventId: number) => {
  const [checkedUsers, setCheckedUsers] = useState<Record<number, number>>({});
  const skipNextSaveRef = useRef(false);

  useLayoutEffect(() => {
    skipNextSaveRef.current = true;

    if (!eventId) {
      setCheckedUsers({});
      return;
    }

    const savedForm = loadInviteFormData(eventId);
    if (hasMeaningfulInviteFormData(savedForm)) {
      const restored = loadSelectedEmployees(eventId)?.checkedUsers ?? {};
      setCheckedUsers(restored);
      return;
    }

    clearSelectedEmployees();
    setCheckedUsers({});
  }, [eventId]);

  useEffect(() => {
    if (!eventId) {
      return;
    }

    if (skipNextSaveRef.current) {
      skipNextSaveRef.current = false;
      return;
    }

    if (!hasMeaningfulInviteFormData(loadInviteFormData(eventId))) {
      return;
    }

    saveSelectedEmployees({ eventId, checkedUsers });
  }, [checkedUsers, eventId]);

  const clearCheckedUsers = useCallback(() => {
    setCheckedUsers({});
  }, []);

  return { checkedUsers, setCheckedUsers, clearCheckedUsers };
};
